import { Button } from "@/components/ui/button";
import { X, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";

export const ListEditor = ({ label, items = [], onChange, placeholder = "Add item...", testId = "list-editor" }) => {
  const add = () => onChange([...(items || []), ""]);
  const update = (i, v) => { const c = [...items]; c[i] = v; onChange(c); };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  return (
    <div data-testid={testId}>
      <div className="mb-1.5 flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">{label}</span>
        <Button type="button" variant="ghost" size="sm" onClick={add} className="h-7 gap-1 text-primary" data-testid={`${testId}-add`}>
          <Plus className="h-3.5 w-3.5" /> Add
        </Button>
      </div>
      <div className="space-y-2">
        {(items || []).length === 0 && <p className="text-xs text-muted-foreground">Nothing yet. Click Add.</p>}
        {(items || []).map((it, i) => (
          <div key={i} className="flex items-center gap-2">
            <Input value={it} onChange={(e) => update(i, e.target.value)} placeholder={placeholder} data-testid={`${testId}-input-${i}`} />
            <Button type="button" variant="ghost" size="icon" className="h-9 w-9 shrink-0 text-muted-foreground hover:text-red-600" onClick={() => remove(i)} data-testid={`${testId}-remove-${i}`}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
